import { Box, Button, Image, Text, useBoolean } from '@chakra-ui/react';
import successImg from 'assets/success.png';
import BaseModal from './BaseModal';
import { useTenant } from 'context/TenantContext';
import useGlobalStore from 'zStore';
import { backToWebApp } from 'utils/helpers';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function DiscountSuccessModal({ isOpen, onClose }: Props) {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <SuccessBody />
    </BaseModal>
  );
}

const SuccessBody = () => {
  const { t } = useTranslation(['order', 'common', 'subscriptions']);
  const { tenant } = useTenant();
  const [selectedSub] = useGlobalStore((state) => [state.subscription]);
  const durationWord = selectedSub?.durationType
    ? t(`subscriptions:durationWord.${selectedSub.durationType}`)
    : selectedSub?.durationWord;

  const [isLoading, setIsLoading] = useBoolean();
  return (
    <Box p="24px 31px" textAlign="center">
      <Text fontWeight={600} fontSize="18px">
        {t('order:discountSuccess.title')}
      </Text>
      <Image mt="4" mx="auto" objectFit="cover" src={successImg} alt={t('order:planLogoAlt')} />
      <Text mt="20px" mb="28px">
        {t('order:discountSuccess.welcome', {
          tenantName: tenant.name,
          durationWord,
          planName: selectedSub?.planName,
        })}
      </Text>
      <Button
        isLoading={isLoading}
        w="100%"
        h="48px"
        bg="primary"
        color="#fff"
        onClick={() => {
          setIsLoading.on();
          backToWebApp(tenant);
        }}
      >
        {t('common:backToApp', { tenantName: tenant.name })}
      </Button>
    </Box>
  );
};
